import { render, staticRenderFns } from "./TheChatTypingIndicator.vue?vue&type=template&id=2384aacc&scoped=true&"
import script from "./TheChatTypingIndicator.vue?vue&type=script&lang=js&"
export * from "./TheChatTypingIndicator.vue?vue&type=script&lang=js&"
import style0 from "./TheChatTypingIndicator.vue?vue&type=style&index=0&id=2384aacc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2384aacc",
  null
  
)

export default component.exports